import React, { useEffect } from "react";
import { Card, Table, Layout, PageHeader, Button } from "antd";
import { observer } from "mobx-react";
import { useHistory, useLocation } from "react-router-dom";
import { fmtDateTime } from "../../common/Utils";
import { bannersStore } from "../../store/content/banner/BannersStore";
import { userActivityStore } from "../../store/activity/UserActivityStore";
import { UserActivityDlg } from "../activities/UserActivityDlg";

export const Banners = observer(() => {
  const location = useLocation();
  const history = useHistory();
  const store = bannersStore;

  const onPage = (page, pageSize) => {
    store.onPage(history, page, pageSize);
  };

  const onChange = (pagination, filters, sorter) => {
    store.sortedInfo = sorter;
    store.refresh();
  };

  useEffect(() => {
    store.onLocation(location);
  }, []);

  useEffect(() => {
    store.onLocation(location);
  }, [location.search]);

  const columns = [
    { title: "", key: "i", render: (t, r, i) => i + 1 },
    {
      title: "Type",
      dataIndex: "type",
      key: "type.keyword",
      // sorter: true,
      // sortOrder: store.sortedInfo.columnKey === "type.keyword" ? (store.sortedInfo.order as SortOrder) : undefined,
    },
    {
      title: "Title",
      dataIndex: ["eduShareOffer", "title"],
      key: "title.keyword",
      //   sorter: true,
      //   sortOrder: store.sortedInfo.columnKey === "type.keyword" ? (store.sortedInfo.order as SortOrder) : undefined,
    },
    {
      title: "Status",
      dataIndex: "state",
      key: "status",
    },
    {
      title: "Create Date",
      dataIndex: "createDate",
      key: "createDate",
      render: fmtDateTime,
      // sorter: true,
      // sortOrder: store.sortedInfo.columnKey === "updatedAt" ? (store.sortedInfo.order as SortOrder) : undefined,
    },
    {
      key: "actions",
      render: (_, r) => (
        <Button
          type="link"
          onClick={() => {
            userActivityStore.showDetail({ id: "PSO__" + r.eduShareOffer?.id, category: "eduShare Offer" });
          }}
        >
          Details
        </Button>
      ),
    },
  ];

  return (
    <Layout.Content className="padding24">
      <PageHeader
        title="Banners"
        extra={
          <Button loading={store.loading} onClick={() => store.refresh()}>
            Refresh
          </Button>
        }
      ></PageHeader>

      <Card size="small">
        <Table
          size="small"
          pagination={{ ...store.pagination, onChange: onPage }}
          loading={store.loading}
          onChange={onChange}
          rowKey="id"
          columns={columns}
          dataSource={store.data.items}
        />
        {userActivityStore.visible && <UserActivityDlg />}
      </Card>
    </Layout.Content>
  );
});
